import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled(Flex)`
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
`;

export const Column = styled(Flex)`
  flex-direction: ${({ reverse }) => (reverse ? "column-reverse" : "column")};
`;

export const Expanded = styled.div`
  flex-grow: 1;
`;
